export const SET = 'localSettings/SET';
